import script from "./UserRegistration.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRegistration.vue?vue&type=script&setup=true&lang=js"

import "./UserRegistration.vue?vue&type=style&index=0&id=388f9fb6&lang=less"

const __exports__ = script;

export default __exports__